import router from '@/modules/productManagement/router'
import { useProductStore } from '@/modules/productManagement/store'
import ProductApi from '@/modules/productManagement/service'
export default {
  store: useProductStore,
  service: new ProductApi(),
  router,
}
